import { createActions, createReducer } from 'reduxsauce'

import MedicoesObrasService from '../../servicos/MedicoesObrasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaMedicoesObrasInicio: [],
    buscaMedicoesObrasSucesso: ['medicoesObras'],
    buscaMedicoesObrasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaMedicoesObras = filtro => {
    return dispatch => {
        dispatch(Creators.buscaMedicoesObrasInicio())
        let serv = new MedicoesObrasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaMedicoesObrasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaMedicoesObrasErro(error)))
    }
}

const buscaMedicoesObrasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaMedicoesObrasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaMedicoesObrasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.medicoesObras, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_MEDICOES_OBRAS_INICIO]: buscaMedicoesObrasInicio,
    [Types.BUSCA_MEDICOES_OBRAS_ERRO]: buscaMedicoesObrasErro,
    [Types.BUSCA_MEDICOES_OBRAS_SUCESSO]: buscaMedicoesObrasSucesso,
})
